(function () {
  if (window.__nccMobileFiltersLoaded) return;
  window.__nccMobileFiltersLoaded = true;

  var MOBILE_QUERY = '(max-width: 768px)';
  var INLINE_WRAP_SELECTOR = '#CollectionInlineFilterWrap';
  var MOBILE_FILTER_WRAPPER_SELECTOR = INLINE_WRAP_SELECTOR + ' .filter-wrapper';
  var MOBILE_SCROLL_AREA_SELECTOR = '.mobile-filter-scroll-area';
  var MOBILE_DRAWER_HEADER_SELECTOR = '.mobile-filter-drawer-header';
  var FOOTER_SELECTOR = '.mobile-filter-actions';
  var RESULTS_COUNT_SELECTOR = '.mobile-filter-results-count';
  var HEADER_SELECTOR = '#HeaderWrapper';
  var FILTER_TRIGGER_SELECTOR = '.collection-filter__btn';
  var HEADER_OFFSET_VAR = '--mobileFilterHeaderOffset';
  var BODY_LOCK_CLASS = 'mobile-filter-body-locked';
  var NCC_PILLS_CLASS  = 'ncc-mobile-active-pills';
  // Per-collection sessionStorage key for the full unfiltered form HTML
  var FORM_CACHE_KEY   = 'ncc_form_v1_' + window.location.pathname;

  var isRunningSetup = false;
  var activeOffsetRaf = null;
  var lockedScrollY = 0;
  var setupDebounceTimer = null;
  var removedOrphanKeys = {};
  var drawerPreviewTimer = null;
  var drawerPreviewRequestId = 0;
  var countLoadingTimer = null;
  var COUNT_LOADING_DELAY_MS = 400;
  var PREVIEW_DEBOUNCE_MS = 250;
  // Expand-all runs once per drawer open so users can still collapse sections.
  var drawerExpandedOnOpen = false;

  // Set true when Reset or pill X updates the URL via pushState.
  // On drawer close we navigate to that URL so the product grid updates.
  var pendingUrlChange = false;

  var _previewAbortController = null;
  var _headerOffsetPending = false;
  var _cachedStyleCSS = null;
  var _cachedWrapper = null;
  var _cachedForm = null;
  var _cachedScrollArea = null;
  var _ric = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1); };

  function getCachedWrapper() {
    if (_cachedWrapper && _cachedWrapper.isConnected) return _cachedWrapper;
    _cachedWrapper = document.querySelector(MOBILE_FILTER_WRAPPER_SELECTOR);
    _cachedForm = null;
    _cachedScrollArea = null;
    return _cachedWrapper;
  }
  function getCachedForm() {
    var w = getCachedWrapper();
    if (!w) return null;
    if (_cachedForm && _cachedForm.isConnected) return _cachedForm;
    _cachedForm = w.querySelector('form');
    return _cachedForm;
  }
  function getCachedScrollArea() {
    var w = getCachedWrapper();
    if (!w) return null;
    if (_cachedScrollArea && _cachedScrollArea.isConnected) return _cachedScrollArea;
    _cachedScrollArea = w.querySelector(MOBILE_SCROLL_AREA_SELECTOR);
    return _cachedScrollArea;
  }
  function invalidateDomCache() {
    _cachedWrapper = null;
    _cachedForm = null;
    _cachedScrollArea = null;
  }

  // ── Debug logging (share console output when reporting issues) ─────────────
  // Enabled by default. Disable: localStorage.setItem('ncc_filter_debug', '0')
  // Re-enable: localStorage.setItem('ncc_filter_debug', '1') then reload.
  var MF_LOG_PREFIX = '[ncc-filters]';
  var mfLogSeq = 0;

  function isMfLogEnabled() {
    try {
      var stored = localStorage.getItem('ncc_filter_debug');
      if (stored === '0') return false;
      if (stored === '1') return true;
    } catch (e) {}
    return true;
  }

  function mfLog(event, detail) {
    if (!isMfLogEnabled()) return;
    mfLogSeq++;
    var payload = {
      seq: mfLogSeq,
      t: Date.now(),
      previewRequestId: drawerPreviewRequestId,
      drawerOpen: isDrawerOpen(),
      url: window.location.pathname + window.location.search
    };
    if (detail && typeof detail === 'object') {
      for (var k in detail) {
        if (Object.prototype.hasOwnProperty.call(detail, k)) payload[k] = detail[k];
      }
    }
    console.log(MF_LOG_PREFIX, event, payload);
  }

  function paramsToFilterObject(params) {
    var out = {};
    if (!params || !params.forEach) return out;
    params.forEach(function (val, key) {
      if (key.indexOf('filter.') !== 0 && key !== 'sort_by') return;
      if (!out[key]) out[key] = [];
      out[key].push(val);
    });
    return out;
  }

  function getDrawerCheckboxSnapshot(wrapper) {
    if (!wrapper) return [];
    var rows = [];
    wrapper.querySelectorAll('input[type="checkbox"]').forEach(function (inp) {
      if (!inp.name || inp.name.indexOf('filter.') !== 0) return;
      rows.push({
        key: inp.name + '::' + inp.value,
        label: getInputLabel(inp),
        checked: inp.checked,
        hasCheckedAttr: inp.hasAttribute('checked'),
        activeLi: !!(inp.closest('li.tag') && inp.closest('li.tag').classList.contains('tag--active')),
        connected: inp.isConnected
      });
    });
    return rows;
  }

  function getCheckedFilterKeys(wrapper) {
    return getDrawerCheckboxSnapshot(wrapper)
      .filter(function (r) { return r.checked; })
      .map(function (r) { return r.key; });
  }

  function mfLogCheckboxMismatch(wrapper, params, context) {
    var mismatches = [];
    wrapper.querySelectorAll('input[type="checkbox"]').forEach(function (inp) {
      if (!inp.name || inp.name.indexOf('filter.') !== 0) return;
      var shouldCheck = false;
      params.getAll(inp.name).forEach(function (val) {
        if (val === inp.value) shouldCheck = true;
      });
      if (inp.checked !== shouldCheck) {
        mismatches.push({
          key: inp.name + '::' + inp.value,
          domChecked: inp.checked,
          paramsWantChecked: shouldCheck,
          connected: inp.isConnected
        });
      }
    });
    if (mismatches.length) {
      mfLog('checkbox:mismatch', {
        context: context,
        mismatches: mismatches,
        params: paramsToFilterObject(params),
        checkedInDom: getCheckedFilterKeys(wrapper)
      });
    }
  }

  // ── HEADER HIDE / RESTORE ──────────────────────────────────────────────────
  // We inject a <style> tag to hide the header + announcement bar on open,
  // and remove it on close.
  //
  // WHY A STYLE TAG instead of saving element .style.display values:
  // Element references go stale when the theme re-renders DOM nodes via AJAX.
  // A style tag has no references — removing it instantly un-hides everything
  // regardless of how many times the DOM has been replaced.

  var HEADER_HIDE_STYLE_ID = 'NccHeaderHideStyle';

  function buildHeaderSelectors() {
    // Always hide #HeaderWrapper
    var sels = ['#HeaderWrapper'];

    // Walk up from #HeaderWrapper to its containing .shopify-section, then
    // collect every .shopify-section BEFORE it — those are announcement bars.
    var header = document.querySelector('#HeaderWrapper');
    if (header) {
      var section = header.parentElement;
      while (section && section !== document.body) {
        if (section.classList && section.classList.contains('shopify-section')) break;
        section = section.parentElement;
      }
      if (section && section.classList && section.classList.contains('shopify-section')) {
        var sibling = section.previousElementSibling;
        while (sibling) {
          if (sibling.id) {
            sels.push('#' + sibling.id.replace(/([!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~])/g, '\\$1'));
          } else if (sibling.className && typeof sibling.className === 'string') {
            var first = sibling.className.trim().split(/\s+/)[0];
            if (first) sels.push('.' + first);
          }
          sibling = sibling.previousElementSibling;
        }
      }
    }
    return sels.join(',');
  }

  function hidePageHeader() {
    if (document.getElementById(HEADER_HIDE_STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = HEADER_HIDE_STYLE_ID;
    style.textContent =
      '@media only screen and (max-width:768px){' +
      buildHeaderSelectors() + '{display:none!important}' +
      '}';
    document.head.appendChild(style);
  }

  function restorePageHeader() {
    var style = document.getElementById(HEADER_HIDE_STYLE_ID);
    if (style && style.parentNode) style.parentNode.removeChild(style);
  }

  // ── FETCH + XHR INTERCEPTION ───────────────────────────────────────────────

  var _originalFetch = window.fetch;
  window.fetch = function (resource, options) {
    if (isMobileViewport() && isDrawerOpen()) {
      var url = typeof resource === 'string'
        ? resource
        : (resource instanceof Request ? resource.url : String(resource));
      if (isFilterAjaxUrl(url)) {
        return new Promise(function () {});
      }
    }
    return _originalFetch.apply(this, arguments);
  };

  var _XHROpen = XMLHttpRequest.prototype.open;
  var _blockedXHRs = new WeakSet();
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isMobileViewport() && isDrawerOpen() && isFilterAjaxUrl(String(url))) {
      _blockedXHRs.add(this);
    }
    return _XHROpen.apply(this, arguments);
  };
  var _XHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (body) {
    if (_blockedXHRs.has(this)) { _blockedXHRs.delete(this); return; }
    return _XHRSend.apply(this, arguments);
  };

  function isFilterAjaxUrl(url) {
    var path = window.location.pathname;
    return (
      url.indexOf(path) !== -1 && (
        url.indexOf('sections') !== -1 ||
        url.indexOf('filter.') !== -1 ||
        url.indexOf('sort_by') !== -1
      )
    );
  }

  // ── Helpers ────────────────────────────────────────────────────────────────

  function isMobileViewport() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function getCurrentSearchParams() {
    return new URLSearchParams(window.location.search);
  }

  function navigateWithParams(params) {
    window.location.search = params.toString();
  }

  function attrEscape(str) {
    return str.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  // ── Header offset ──────────────────────────────────────────────────────────

  function syncHeaderOffsetVar() {
    if (!isMobileViewport()) return;
    if (_headerOffsetPending) return;
    _headerOffsetPending = true;
    requestAnimationFrame(function () {
      _headerOffsetPending = false;
      var header = document.querySelector(HEADER_SELECTOR);
      var headerOffset = 0;
      if (header) headerOffset = Math.max(0, header.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty(HEADER_OFFSET_VAR, headerOffset + 'px');
    });
  }

  // ── Drawer state ───────────────────────────────────────────────────────────

  function isFilterDrawerActive(wrapper) {
    if (!wrapper) wrapper = getCachedWrapper();
    if (!wrapper) return false;
    if (wrapper.classList.contains('is-active')) return true;
    var inlineWrap = wrapper.closest(INLINE_WRAP_SELECTOR);
    return Boolean(inlineWrap && inlineWrap.classList.contains('is-active'));
  }

  function isDrawerOpen() {
    return isFilterDrawerActive(getCachedWrapper());
  }

  // ── Body scroll lock ───────────────────────────────────────────────────────

  function lockBodyScroll() {
    if (!isMobileViewport() || document.body.classList.contains(BODY_LOCK_CLASS)) return;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.classList.add(BODY_LOCK_CLASS);
    document.body.style.position = 'fixed';
    document.body.style.top = -lockedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.overscrollBehavior = 'none';
    // Hide header + announcement bar so drawer fills the full screen
    hidePageHeader();
  }

  function unlockBodyScroll() {
    if (!document.body.classList.contains(BODY_LOCK_CLASS)) return;
    document.body.classList.remove(BODY_LOCK_CLASS);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    document.documentElement.style.overscrollBehavior = '';
    window.scrollTo(0, lockedScrollY);
    lockedScrollY = 0;
    // Restore header + announcement bar
    restorePageHeader();
  }

  // ── RAF sync loop ──────────────────────────────────────────────────────────

  function stopOffsetSyncLoop() {
    if (activeOffsetRaf !== null) {
      cancelAnimationFrame(activeOffsetRaf);
      activeOffsetRaf = null;
    }
  }

  function startOffsetSyncLoop() {
    if (activeOffsetRaf !== null) return;
    function tick() {
      if (!isDrawerOpen()) { stopOffsetSyncLoop(); return; }
      syncHeaderOffsetVar();
      activeOffsetRaf = requestAnimationFrame(tick);
    }
    activeOffsetRaf = requestAnimationFrame(tick);
  }

  function syncDrawerOpenState() {
    if (!isMobileViewport()) {
      stopOffsetSyncLoop();
      unlockBodyScroll();
      return;
    }
    if (isDrawerOpen()) {
      syncHeaderOffsetVar();
      lockBodyScroll();
      startOffsetSyncLoop();
      return;
    }
    stopOffsetSyncLoop();
    unlockBodyScroll();
  }

  // ── Close drawer ───────────────────────────────────────────────────────────

  function closeMobileFilterDrawer() {
    var wrapper = getCachedWrapper();
    if (!wrapper || !wrapper.classList.contains('is-active')) return;
    var trigger = document.querySelector(FILTER_TRIGGER_SELECTOR);
    if (trigger) { trigger.click(); return; }
    wrapper.classList.remove('is-active');
  }

  // ── Drawer header ──────────────────────────────────────────────────────────

  function createDrawerHeader() {
    var header = document.createElement('div');
    header.className = 'mobile-filter-drawer-header';
    var title = document.createElement('span');
    title.className = 'mobile-filter-drawer-title';
    title.textContent = 'Filters';
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'mobile-filter-drawer-close';
    closeBtn.setAttribute('aria-label', 'Close filters');
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', closeMobileFilterDrawer);
    header.appendChild(title);
    header.appendChild(closeBtn);
    return header;
  }

  // ── Pill container ─────────────────────────────────────────────────────────

  function getPillContainer() {
    var wrapper = getCachedWrapper();
    if (!wrapper) return null;
    var existing = wrapper.querySelector('.' + NCC_PILLS_CLASS);
    if (existing) return existing;
    var container = document.createElement('ul');
    container.className = 'no-bullets tag-list ' + NCC_PILLS_CLASS;
    var scrollArea = wrapper.querySelector(MOBILE_SCROLL_AREA_SELECTOR);
    if (scrollArea) {
      scrollArea.insertBefore(container, scrollArea.firstChild);
    } else {
      var drawerHeader = wrapper.querySelector(MOBILE_DRAWER_HEADER_SELECTOR);
      if (drawerHeader && drawerHeader.nextSibling) {
        wrapper.insertBefore(container, drawerHeader.nextSibling);
      } else {
        wrapper.insertBefore(container, wrapper.firstChild);
      }
    }
    return container;
  }

  var PRICE_GROUP_ID = '__price_range__';

  function pillKeyFor(name, value) { return name + '::' + value; }

  function getInputLabel(input) {
    var li = input.closest('li');
    if (li) {
      var textEl = li.querySelector('.tag__text');
      if (textEl) return textEl.textContent.trim();
      return li.textContent.trim();
    }
    return input.value;
  }

  function getFilterGroupLabel(el) {
    var group = el.closest('.collection-sidebar__group');
    if (!group) return 'Filter';
    var trigger = group.querySelector('.collapsible-trigger');
    if (!trigger) return 'Filter';
    var labelSpan = trigger.querySelector(
      '.collapsible-trigger__layout--inline > span, .collapsible-trigger__layout > span'
    );
    if (labelSpan) return labelSpan.textContent.trim();
    return trigger.textContent.trim().split('\n')[0].trim() || 'Filter';
  }

  function getGroupLabelForParamName(wrapper, paramName) {
    var sample = wrapper.querySelector('input[name="' + attrEscape(paramName) + '"]');
    if (sample) return getFilterGroupLabel(sample);
    if (paramName.indexOf('filter.') !== -1 && /price|amount/i.test(paramName)) return 'Price';
    return 'Filter';
  }

  function uncheckFilterByKey(wrapper, key, logContext) {
    if (!wrapper || !key) return { matched: 0, inputs: [] };
    var sep = key.indexOf('::');
    if (sep === -1) return { matched: 0, inputs: [] };
    var name = key.slice(0, sep);
    var value = key.slice(sep + 2);
    var matched = [];
    wrapper.querySelectorAll('input[name="' + attrEscape(name) + '"]').forEach(function (inp) {
      if (inp.value !== value) return;
      var before = {
        checked: inp.checked,
        hasCheckedAttr: inp.hasAttribute('checked'),
        connected: inp.isConnected
      };
      inp.checked = false;
      inp.removeAttribute('checked');
      var li = inp.closest('li.tag');
      if (li) li.classList.remove('tag--active');
      matched.push({
        before: before,
        after: { checked: inp.checked, hasCheckedAttr: inp.hasAttribute('checked') }
      });
    });
    mfLog('uncheckFilterByKey', {
      context: logContext || 'unknown',
      key: key,
      matchedCount: matched.length,
      matched: matched,
      checkedAfter: getCheckedFilterKeys(wrapper)
    });
    return { matched: matched.length, inputs: matched };
  }

  // Instant selected styling — do not wait for preview fetch.
  function syncFilterCheckboxUi(input) {
    if (!input || input.type !== 'checkbox') return;
    var li = input.closest('li.tag');
    if (input.checked) {
      input.setAttribute('checked', 'checked');
      if (li) li.classList.add('tag--active');
    } else {
      input.removeAttribute('checked');
      if (li) li.classList.remove('tag--active');
    }
  }

  function syncFiltersAfterPillRemoval(wrapper, removedKey) {
    var prevRequestId = drawerPreviewRequestId;
    clearTimeout(drawerPreviewTimer);
    drawerPreviewRequestId++;

    mfLog('pill:syncFiltersAfterPillRemoval:start', {
      removedKey: removedKey,
      prevPreviewRequestId: prevRequestId,
      newPreviewRequestId: drawerPreviewRequestId,
      checkedBefore: getCheckedFilterKeys(wrapper)
    });

    if (removedKey) uncheckFilterByKey(wrapper, removedKey, 'syncFiltersAfterPillRemoval');

    var params = buildFilterParamsFromWrapper(wrapper);
    syncCheckboxStateFromParams(wrapper, params, 'syncFiltersAfterPillRemoval');
    mfLogCheckboxMismatch(wrapper, params, 'after syncFiltersAfterPillRemoval');

    var qs = params.toString();
    var cleanUrl = window.location.pathname + (qs ? '?' + qs : '');
    history.pushState({}, '', cleanUrl);
    pendingUrlChange = true;

    mfLog('pill:syncFiltersAfterPillRemoval:pushState', {
      removedKey: removedKey,
      cleanUrl: cleanUrl,
      params: paramsToFilterObject(params),
      checkedAfterSync: getCheckedFilterKeys(wrapper)
    });

    rebuildGroupedPills();
    softReset(cleanUrl, wrapper, params);
  }

  function clearPriceRangeFilter(priceRange) {
    if (!priceRange) return;
    var minRange = priceRange.getAttribute('data-min');
    var maxRange = priceRange.getAttribute('data-max');
    priceRange.setAttribute('data-min-value', minRange);
    priceRange.setAttribute('data-max-value', maxRange);
    var minInp = priceRange.querySelector('.price-range__input-min');
    var maxInp = priceRange.querySelector('.price-range__input-max');
    if (minInp) minInp.value = minRange;
    if (maxInp) maxInp.value = maxRange;
    var slider = priceRange.querySelector('.price-range__slider');
    if (slider && slider.noUiSlider) {
      slider.noUiSlider.set([parseFloat(minRange), parseFloat(maxRange)]);
    }
    priceRange.dispatchEvent(new CustomEvent('price-range:change', { bubbles: true }));
  }

  function getPriceRangeSelection(wrapper) {
    var priceRange = wrapper.querySelector('.price-range');
    if (!priceRange) return null;
    var minRange = parseFloat(priceRange.getAttribute('data-min'));
    var maxRange = parseFloat(priceRange.getAttribute('data-max'));
    var minValue = parseFloat(priceRange.getAttribute('data-min-value'));
    var maxValue = parseFloat(priceRange.getAttribute('data-max-value'));
    if (isNaN(minRange) || isNaN(maxRange)) return null;
    if (isNaN(minValue)) minValue = minRange;
    if (isNaN(maxValue)) maxValue = maxRange;
    if (minValue <= minRange && maxValue >= maxRange) return null;

    var displayMin = priceRange.querySelector('.price-range__display-min');
    var displayMax = priceRange.querySelector('.price-range__display-max');
    var textMin = displayMin ? displayMin.textContent.trim() : String(minValue);
    var textMax = displayMax ? displayMax.textContent.trim() : String(maxValue);

    return {
      groupId: PRICE_GROUP_ID,
      label: getFilterGroupLabel(priceRange),
      display: textMin + '-' + textMax,
      priceRange: priceRange
    };
  }

  function createPillRemoveButton(ariaLabel) {
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'tag-pill-remove-btn';
    closeBtn.setAttribute('aria-label', ariaLabel || 'Remove filter');
    closeBtn.innerHTML = '&times;';
    return closeBtn;
  }

  function createGroupedPillValue(key, label, options) {
    var valueEl = document.createElement('span');
    valueEl.className = 'ncc-pill-value';
    valueEl.setAttribute('data-key', key);
    if (options.orphan) valueEl.setAttribute('data-orphan', '1');

    var text = document.createElement('span');
    text.className = 'ncc-pill-value__text';
    text.textContent = label;
    valueEl.appendChild(text);

    var closeBtn = createPillRemoveButton('Remove ' + label);
    closeBtn.addEventListener('click', function (event) {
      event.stopImmediatePropagation();
      event.preventDefault();
      var wrapper = getCachedWrapper();
      if (!wrapper) return;

      mfLog('pill:remove:click', {
        key: key,
        label: label,
        orphan: !!options.orphan,
        hasPriceRange: !!options.priceRange,
        hadInputRef: !!options.input,
        inputRefConnected: options.input ? options.input.isConnected : null,
        checkedBefore: getCheckedFilterKeys(wrapper)
      });

      if (options.priceRange) {
        clearPriceRangeFilter(options.priceRange);
      } else {
        // Block URL from re-adding this filter as an "orphan" pill before pushState runs.
        removedOrphanKeys[key] = true;
        uncheckFilterByKey(wrapper, key, 'pill:remove');
      }

      // Do not rebuildGroupedPills() here — URL still has the old filter and would
      // recreate an orphan pill that buildFilterParamsFromWrapper would re-append.
      syncFiltersAfterPillRemoval(wrapper, key);
    });
    valueEl.appendChild(closeBtn);
    return valueEl;
  }

  function rebuildGroupedPills() {
    if (!isMobileViewport()) return;
    var wrapper = getCachedWrapper();
    if (!wrapper) return;
    var container = getPillContainer();
    if (!container) return;

    container.innerHTML = '';
    var groups = {};
    var groupOrder = [];

    wrapper.querySelectorAll('.collection-sidebar__group').forEach(function (groupEl) {
      if (groupEl.classList.contains('collection-sidebar__group--sort')) return;
      if (groupEl.querySelector('.price-range')) {
        if (groupOrder.indexOf(PRICE_GROUP_ID) === -1) groupOrder.push(PRICE_GROUP_ID);
        return;
      }
      var sample = groupEl.querySelector('input[type="checkbox"]');
      if (sample && groupOrder.indexOf(sample.name) === -1) groupOrder.push(sample.name);
    });

    function ensureGroup(groupId, label) {
      if (!groups[groupId]) {
        groups[groupId] = { label: label, items: [] };
        if (groupOrder.indexOf(groupId) === -1) groupOrder.push(groupId);
      }
      return groups[groupId];
    }

    wrapper.querySelectorAll('form input[type="checkbox"]:checked').forEach(function (input) {
      var groupId = input.name;
      var g = ensureGroup(groupId, getFilterGroupLabel(input));
      g.items.push({
        key: pillKeyFor(input.name, input.value),
        label: getInputLabel(input),
        input: input,
        orphan: false
      });
    });

    var priceSelection = getPriceRangeSelection(wrapper);
    if (priceSelection) {
      var priceGroup = ensureGroup(priceSelection.groupId, priceSelection.label);
      priceGroup.items.push({
        key: PRICE_GROUP_ID + '::range',
        label: priceSelection.display,
        priceRange: priceSelection.priceRange
      });
    }

    getCurrentSearchParams().forEach(function (value, name) {
      if (name.indexOf('filter.') !== 0) return;
      var key = pillKeyFor(name, value);
      if (removedOrphanKeys[key]) return;
      var input = wrapper.querySelector(
        'input[name="' + attrEscape(name) + '"][value="' + attrEscape(value) + '"]'
      );
      if (input && input.checked) return;

      var groupId = name;
      var g = ensureGroup(groupId, getGroupLabelForParamName(wrapper, name));
      var already = g.items.some(function (item) { return item.key === key; });
      if (!already) {
        g.items.push({ key: key, label: value, orphan: true });
      }
    });

    groupOrder.forEach(function (groupId) {
      var g = groups[groupId];
      if (!g || !g.items.length) return;

      var li = document.createElement('li');
      li.className = 'ncc-pill-group';
      li.setAttribute('data-group-id', groupId);

      var labelEl = document.createElement('span');
      labelEl.className = 'ncc-pill-group__label';
      labelEl.textContent = g.label + ':';

      var valuesEl = document.createElement('span');
      valuesEl.className = 'ncc-pill-group__values';

      g.items.forEach(function (item) {
        valuesEl.appendChild(createGroupedPillValue(item.key, item.label, {
          input: item.input,
          orphan: item.orphan,
          priceRange: item.priceRange
        }));
      });

      li.appendChild(labelEl);
      li.appendChild(valuesEl);
      container.appendChild(li);
    });
  }

  function seedPillsFromURL() {
    rebuildGroupedPills();
  }

  // ── Collapsible height recalc ──────────────────────────────────────────────

  function recalcCollapsibleHeights(wrapper) {
    wrapper.querySelectorAll('.collapsible-content.is-open').forEach(function (el) {
      var inner = el.querySelector('.collapsible-content__inner');
      if (inner) el.style.height = inner.scrollHeight + 'px';
    });
  }

  function expandAllDrawerCollapsibles(wrapper) {
    if (!wrapper) return;
    var scope = wrapper.querySelector(MOBILE_SCROLL_AREA_SELECTOR) || wrapper;

    scope.querySelectorAll('.collapsible-content.collapsible-content--all').forEach(function (content) {
      var inner = content.querySelector('.collapsible-content__inner');
      content.classList.add('is-open');
      content.style.overflow = '';
      content.style.opacity = '';
      content.style.visibility = '';
      if (inner) {
        content.style.height = inner.scrollHeight + 'px';
      } else {
        content.style.height = 'auto';
      }
    });

    scope.querySelectorAll('.collapsible-trigger').forEach(function (trigger) {
      trigger.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    });

    scope.querySelectorAll('.collection-sidebar__group').forEach(function (group) {
      if (!group.querySelector('li.tag--swatch, .color-swatch--filter')) return;
      group.style.overflow = 'visible';
      var content = group.querySelector('.collapsible-content.collapsible-content--all');
      if (content) {
        content.style.height = 'auto';
        content.style.maxHeight = 'none';
        content.style.overflow = 'visible';
      }
      var inner = group.querySelector('.collapsible-content__inner');
      if (inner) inner.style.overflow = 'visible';
    });
  }

  function resetDrawerExpandState() {
    drawerExpandedOnOpen = false;
  }

  function classAttrHasToken(classAttr, token) {
    if (!classAttr || !token) return false;
    return (' ' + classAttr + ' ').indexOf(' ' + token + ' ') !== -1;
  }

  function ensureDrawerCollapsiblesExpanded(wrapper) {
    if (!wrapper || !isDrawerOpen()) return;
    expandAllDrawerCollapsibles(wrapper);
    recalcCollapsibleHeights(wrapper);
  }

  function onDrawerOpened() {
    var wrapper = document.querySelector(MOBILE_FILTER_WRAPPER_SELECTOR) || getCachedWrapper();
    if (!wrapper || !isFilterDrawerActive(wrapper)) return;

    expandAllDrawerCollapsibles(wrapper);
    drawerExpandedOnOpen = true;

    requestAnimationFrame(function () {
      if (!isDrawerOpen()) return;
      recalcCollapsibleHeights(wrapper);
      markColorFilterLists(wrapper);
      setTimeout(function () {
        if (isDrawerOpen()) refreshDrawerPreview('drawer:open');
      }, 80);
    });
  }

  // Color facet lists (tag--swatch) — 4-column pill layout with swatch + label.
  function markColorFilterLists(wrapper) {
    if (!wrapper) return;
    wrapper.querySelectorAll('.collapsible-content__inner .tag-list').forEach(function (list) {
      if (list.classList.contains(NCC_PILLS_CLASS) || list.classList.contains('tag-list--active-tags')) {
        return;
      }
      if (list.querySelector('li.tag--swatch, .color-swatch--filter')) {
        list.classList.add('ncc-color-filter-list');
        list.classList.add('tag-list--swatches');
        list.querySelectorAll('li.tag--swatch .tag__text').forEach(function (textEl) {
          textEl.classList.remove('hide');
        });
      } else {
        list.classList.remove('ncc-color-filter-list');
        list.classList.remove('tag-list--swatches');
      }
    });
  }

  // ── Drawer structure ───────────────────────────────────────────────────────

  function ensureDrawerStructure() {
    var wrapper = getCachedWrapper();
    if (!wrapper) return;
    var footer = wrapper.querySelector(FOOTER_SELECTOR);
    if (!footer) return;

    var drawerHeader = wrapper.querySelector(MOBILE_DRAWER_HEADER_SELECTOR);
    if (!drawerHeader) {
      drawerHeader = createDrawerHeader();
      wrapper.insertBefore(drawerHeader, wrapper.firstChild);
    }

    var scrollArea = wrapper.querySelector(MOBILE_SCROLL_AREA_SELECTOR);
    if (!scrollArea) {
      scrollArea = document.createElement('div');
      scrollArea.className = MOBILE_SCROLL_AREA_SELECTOR.replace('.', '');
      wrapper.insertBefore(scrollArea, footer);
    }
    _cachedScrollArea = null;

    var ourPills = wrapper.querySelector('.' + NCC_PILLS_CLASS);

    // Keep pills inside the scroll area so they scroll with filter options.
    if (ourPills && ourPills.parentElement !== scrollArea) {
      scrollArea.insertBefore(ourPills, scrollArea.firstChild);
    }

    Array.from(wrapper.children).forEach(function (child) {
      if (child === footer || child === scrollArea || child === drawerHeader) return;
      scrollArea.appendChild(child);
    });

    recalcCollapsibleHeights(wrapper);
  }

  // ── Styles ─────────────────────────────────────────────────────────────────

  // function injectActionStyles() {
  //   var style = document.getElementById('MobileFilterActionStyles');
  //   if (!style) {
  //     style = document.createElement('style');
  //     style.id = 'MobileFilterActionStyles';
  //     document.head.appendChild(style);
  //   }
  //   style.textContent = [
  //     '@media only screen and (max-width:768px){',
  //     '.collection-mobile-filters .tag-list--active-tags{display:none!important;}',
  //     '.collection-mobile-filters .collection-sidebar__group--sort{display:none!important;}',
  //     '.collection-mobile-filters{position:static;height:auto;}',
  //     // Drawer — top:0 now that the header is hidden when open
  //     '.collection-mobile-filters .filter-wrapper{',
  //       'position:fixed;top:0;left:0;right:0;bottom:0;',
  //       'z-index:35;',
  //       'height:100vh;max-height:100vh;',
  //       'overflow:hidden;padding-bottom:0;',
  //     '}',
  //     '@supports (height:100dvh){',
  //       '.collection-mobile-filters .filter-wrapper{',
  //         'height:100dvh;max-height:100dvh;',
  //       '}',
  //     '}',
  //     '.collection-mobile-filters .filter-wrapper.is-active{',
  //       'display:flex;flex-direction:column;transform:translateY(0);',
  //     '}',
  //     '.collection-mobile-filters .mobile-filter-drawer-header{',
  //       'flex:0 0 auto;display:flex;align-items:center;',
  //       'justify-content:space-between;padding:10px 20px;',
  //       'border-bottom:1px solid var(--colorBorder);',
  //     '}',
  //     '.collection-mobile-filters .mobile-filter-drawer-title{',
  //       'margin:0;font-size:25px;line-height:1.1;font-weight:400;',
  //     '}',
  //     '.collection-mobile-filters .mobile-filter-drawer-close{',
  //       'appearance:none;background:transparent;border:0;',
  //       'color:var(--colorTextBody);cursor:pointer;font-size:38px;',
  //       'line-height:1;padding:0 2px;',
  //     '}',
  //     '.collection-mobile-filters .' + NCC_PILLS_CLASS + '{',
  //       'flex:0 0 auto;list-style:none;margin:0;',
  //       'padding:8px 16px;display:flex;flex-wrap:wrap;',
  //       'border-bottom:1px solid var(--colorBorder);',
  //     '}',
  //     '.collection-mobile-filters .' + NCC_PILLS_CLASS + ':empty{display:none;}',
  //     '.collection-mobile-filters .' + NCC_PILLS_CLASS + ' .ncc-pill-group{',
  //       'display:flex;flex-wrap:wrap;align-items:center;gap:4px 8px;',
  //       'background:#fff;border:1px solid var(--colorNavSearch,#4d4d5e);',
  //       'border-radius:4px;padding:6px 10px;margin:4px 6px 4px 0;',
  //       'font-size:13px;color:var(--colorNavSearch,#4d4d5e);max-width:100%;',
  //     '}',
  //     '.collection-mobile-filters .' + NCC_PILLS_CLASS + ' .ncc-pill-group__label{',
  //       'font-weight:600;flex-shrink:0;',
  //     '}',
  //     '.collection-mobile-filters .' + NCC_PILLS_CLASS + ' .ncc-pill-group__values{',
  //       'display:inline-flex;flex-wrap:wrap;align-items:center;gap:2px 8px;',
  //     '}',
  //     '.collection-mobile-filters .' + NCC_PILLS_CLASS + ' .ncc-pill-value{',
  //       'display:inline-flex;align-items:center;gap:2px;',
  //     '}',
  //     '.collection-mobile-filters .' + NCC_PILLS_CLASS + ' .tag-pill-remove-btn{',
  //       'background:none;border:none;cursor:pointer;padding:0 0 0 2px;',
  //       'font-size:14px;line-height:1;color:var(--colorNavSearch,#4d4d5e);',
  //     '}',
  //     '.collection-mobile-filters .collapsible-content__inner .tag-list li.hide{',
  //       'display:none!important;',
  //     '}',
  //     '.collection-mobile-filters .mobile-filter-scroll-area{',
  //       'flex:1 1 auto;min-height:0;overflow-y:auto;overflow-x:hidden;',
  //       'padding-bottom:16px;-webkit-overflow-scrolling:touch;',
  //       'touch-action:pan-y;overscroll-behavior:contain;',
  //     '}',
  //     '.collection-mobile-filters .mobile-filter-actions{',
  //       'flex:0 0 auto;display:flex;flex-direction:column;gap:12px;',
  //       'padding:12px 20px calc(16px + env(safe-area-inset-bottom,0px));',
  //       'background:var(--colorBody);border-top:1px solid var(--colorBorder);',
  //     '}',
  //     '.collection-mobile-filters .mobile-filter-results-count{',
  //       'margin:0;padding:0 4px;text-align:center;',
  //       'font-size:inherit;line-height:1.4;color:var(--colorTextBody);',
  //     '}',
  //     '.collection-mobile-filters .mobile-filter-results-count.is-loading{',
  //       'opacity:1;',
  //     '}',
  //     '.collection-mobile-filters .mobile-filter-actions__buttons{',
  //       'display:flex;gap:12px;',
  //     '}',
  //     '.collection-mobile-filters .mobile-filter-actions__btn{flex:1;min-height:46px;}',
  //     '.collection-mobile-filters .mobile-filter-actions__btn--reset{',
  //       'background:transparent;color:var(--colorTextBody);',
  //       'border:1px solid var(--colorTextBody);',
  //     '}',
  //     '.collection-mobile-filters .mobile-filter-actions__btn--reset:hover,',
  //     '.collection-mobile-filters .mobile-filter-actions__btn--reset:focus{',
  //       'background:transparent;color:var(--colorTextBody);',
  //     '}',
  //     '}'
  //   ].join('');
  // }

  function injectActionStyles() {
    var style = document.getElementById('MobileFilterActionStyles');
    if (!style) {
      style = document.createElement('style');
      style.id = 'MobileFilterActionStyles';
      document.head.appendChild(style);
    }
    if (!_cachedStyleCSS) {
      _cachedStyleCSS = [
      '@media only screen and (max-width:768px){',
      '.collection-mobile-filters .tag-list--active-tags{display:none!important;}',
      '.collection-mobile-filters .collection-sidebar__group--sort{display:none!important;}',
      '.collection-mobile-filters{position:static;height:auto;}',
      '.collection-mobile-filters .filter-wrapper{',
        'position:fixed;top:0;left:0;right:0;bottom:0;',
        'z-index:35;',
        'height:100vh;max-height:100vh;',
        'overflow:hidden;padding-bottom:0;',
        'will-change:transform;contain:layout style;',
      '}',
      '@supports (height:100dvh){',
        '.collection-mobile-filters .filter-wrapper{',
          'height:100dvh;max-height:100dvh;',
        '}',
      '}',
      '.collection-mobile-filters .filter-wrapper.is-active,',
      '#CollectionInlineFilterWrap.is-active .filter-wrapper,',
      '.collection-mobile-filters.is-active .filter-wrapper{',
        'display:flex!important;flex-direction:column;transform:translateY(0);',
      '}',
      '.collection-mobile-filters .mobile-filter-drawer-header{',
        'flex:0 0 auto;display:flex;align-items:center;',
        'justify-content:space-between;padding:10px 20px;',
        'border-bottom:1px solid var(--colorBorder);',
      '}',
      '.collection-mobile-filters .mobile-filter-drawer-title{',
        'margin:0;font-size:25px;line-height:1.1;font-weight:400;',
      '}',
      '.collection-mobile-filters .mobile-filter-drawer-close{',
        'appearance:none;background:transparent;border:0;',
        'color:var(--colorTextBody);cursor:pointer;font-size:38px;',
        'line-height:1;padding:0 2px;',
      '}',
      '.collection-mobile-filters .' + NCC_PILLS_CLASS + '{',
        'list-style:none;margin:0;',
        'padding:8px 16px;display:flex;flex-wrap:wrap;',
        'border-bottom:1px solid var(--colorBorder);',
      '}',
      '.collection-mobile-filters .' + NCC_PILLS_CLASS + ':empty{display:none;}',
      '.collection-mobile-filters .' + NCC_PILLS_CLASS + ' .ncc-pill-group{',
        'display:flex;flex-wrap:wrap;align-items:center;gap:4px 8px;',
        'background:#fff;border:1px solid var(--colorNavSearch,#4d4d5e);',
        'border-radius:4px;padding:0px 10px;margin:4px 6px 4px 0;',
        'font-size:13px;color:var(--colorNavSearch,#4d4d5e);max-width:100%;',
      '}',
      '.collection-mobile-filters .' + NCC_PILLS_CLASS + ' .ncc-pill-group__label{',
        'font-weight:600;flex-shrink:0;',
      '}',
      '.collection-mobile-filters .' + NCC_PILLS_CLASS + ' .ncc-pill-group__values{',
        'display:inline-flex;flex-wrap:wrap;align-items:center;gap:2px 8px;',
      '}',
      '.collection-mobile-filters .' + NCC_PILLS_CLASS + ' .ncc-pill-value{',
        'display:inline-flex;align-items:center;gap:2px;',
      '}',
      '.collection-mobile-filters .' + NCC_PILLS_CLASS + ' .tag-pill-remove-btn{',
        'background:none;border:none;cursor:pointer;padding:0 0 3px 2px;',
        'font-size:30px;line-height:1;color:var(--colorNavSearch,#4d4d5e);',
      '}',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.hide,',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag.hide{',
        'display:none!important;visibility:hidden!important;',
        'height:0!important;min-height:0!important;padding:0!important;margin:0!important;',
        'overflow:hidden!important;pointer-events:none!important;',
      '}',
      '.collection-mobile-filters .mobile-filter-scroll-area{',
        'flex:1 1 auto;min-height:0;overflow-y:auto;overflow-x:visible;',
        'padding-bottom:16px;-webkit-overflow-scrolling:touch;',
        'touch-action:pan-y;',
      '}',
      '.collection-mobile-filters .mobile-filter-actions{',
        'flex:0 0 auto;display:flex;flex-direction:column;gap:12px;',
        'padding:12px 20px calc(16px + env(safe-area-inset-bottom,0px));',
        'background:var(--colorBody);border-top:1px solid var(--colorBorder);',
      '}',
      '.collection-mobile-filters .mobile-filter-results-count{',
        'margin:0;padding:0 4px;text-align:center;display:none;',
        'font-size:inherit;line-height:1.4;color:var(--colorTextBody);',
      '}',
      '.collection-mobile-filters .mobile-filter-results-count.is-loading{',
        'opacity:1;display:none;',
      '}',
      '.collection-mobile-filters .mobile-filter-actions__buttons{',
        'display:flex;gap:12px;',
      '}',
      '.collection-mobile-filters .mobile-filter-actions__btn{flex:1;min-height:46px;}',
      '.collection-mobile-filters .mobile-filter-actions__btn--reset{',
        'background:transparent;color:var(--colorTextBody);',
        'border:1px solid var(--colorTextBody);',
      '}',
      '.collection-mobile-filters .mobile-filter-actions__btn--reset:hover,',
      '.collection-mobile-filters .mobile-filter-actions__btn--reset:focus{',
        'background:transparent;color:var(--colorTextBody);',
      '}',
      '.collection-mobile-filters .tag__checkbox{width:24px;height:24px;min-width:24px;}',
      '.collection-mobile-filters .tag__text{font-size:12px;line-height:1.3;}',
      '.collection-mobile-filters .collapsible-content__inner .tag-list:not(.tag-list--active-tags):not(.' + NCC_PILLS_CLASS + '):not(.ncc-color-filter-list):not(.tag-list--swatches):not(:has(li.tag--swatch)){',
        'display:grid!important;',
        'grid-template-columns:repeat(2,minmax(0,1fr));',
        'column-gap:12px;row-gap:4px;',
        'columns:auto!important;column-count:auto!important;',
      '}',
      '.collection-mobile-filters .collection-sidebar__group:has(li.tag--swatch){',
        'overflow:visible!important;',
      '}',
      '.collection-mobile-filters .collection-sidebar__group:has(li.tag--swatch) .collapsible-content,',
      '.collection-mobile-filters .collection-sidebar__group:has(li.tag--swatch) .collapsible-content__inner{',
        'overflow:visible!important;',
      '}',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag:not(.hide):not(.tag--swatch){',
        'display:flex!important;align-items:center!important;',
        'width:100%!important;max-width:100%!important;flex:none!important;',
        'overflow:visible;word-break:normal;padding:4px 0;',
      '}',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag:not(.hide):not(.tag--swatch) > a,',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag:not(.hide):not(.tag--swatch) > label,',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag:not(.hide):not(.tag--swatch) .tag__checkbox-wrapper{',
        'display:inline-flex!important;flex-direction:row!important;flex-wrap:nowrap!important;',
        'align-items:center!important;gap:8px;width:100%;padding:0;margin:0;',
        'font-size:12px;line-height:1.3;',
        'text-decoration:none!important;-webkit-tap-highlight-color:transparent;',
      '}',
      '.collection-mobile-filters .tag__checkbox-wrapper .tag__text,',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag .tag__text{',
        'display:inline!important;flex:1;min-width:0;',
        'overflow-wrap:break-word;word-break:break-word;',
      '}',
      '.collection-mobile-filters .tag__checkbox-custom,',
      '.collection-mobile-filters .icon--checkbox{flex-shrink:0;}',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag a:link,',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag a:visited,',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag a:hover,',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag a:active,',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag a:focus,',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag.tag--active a,',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag.tag--active .tag__text{',
        'text-decoration:none!important;',
        'text-decoration-line:none!important;',
        'border-bottom:none!important;',
        'box-shadow:none!important;',
      '}',
      '.collection-mobile-filters .collapsible-content__inner .tag-list.ncc-color-filter-list,',
      '.collection-mobile-filters .collapsible-content__inner .tag-list.tag-list--swatches,',
      '.collection-mobile-filters .collapsible-content__inner .tag-list:has(li.tag--swatch){',
        'display:flex!important;flex-flow:row wrap!important;align-items:flex-start!important;',
        'align-content:flex-start!important;gap:8px!important;width:100%!important;',
        'max-width:100%!important;grid-template-columns:none!important;',
        'columns:auto!important;column-count:auto!important;column-width:auto!important;',
      '}',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag--swatch:not(.hide){',
        'display:inline-flex!important;padding:0!important;margin:0!important;',
        'width:auto!important;max-width:100%!important;flex:0 0 auto!important;',
        'overflow:visible!important;',
      '}',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag--swatch:not(.hide) .tag__checkbox-wrapper{',
        'display:inline-flex!important;flex-direction:row!important;align-items:center!important;',
        'flex-wrap:nowrap!important;gap:6px!important;',
        'width:auto!important;max-width:none!important;margin:0!important;',
        'padding:4px 10px 4px 4px!important;font-size:13px!important;',
        'background:#fff!important;border:1px solid rgba(0,0,0,0.12)!important;',
        'border-radius:999px!important;box-sizing:border-box!important;cursor:pointer!important;',
        'overflow:visible!important;white-space:nowrap!important;',
      '}',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag--swatch .tag__checkbox-wrapper:has(.tag__input:checked),',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag--swatch.tag--active .tag__checkbox-wrapper{',
        'background:#ececec!important;',
        'border-color:rgba(0,0,0,0.18)!important;',
        'box-shadow:none!important;',
      '}',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag--swatch .tag__input{',
        'position:absolute!important;opacity:0!important;pointer-events:none!important;',
        'width:1px!important;height:1px!important;margin:0!important;',
      '}',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag--swatch .color-swatch--filter,',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag--swatch .color-swatch{',
        'width:28px!important;height:28px!important;min-width:28px!important;max-width:28px!important;',
        'flex:0 0 28px!important;margin:0!important;border-radius:50%!important;',
        'box-shadow:0 0 0 1px rgba(0,0,0,0.12)!important;',
        'text-indent:-9999px!important;overflow:hidden!important;',
      '}',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag--swatch .color-swatch:before,',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag--swatch .color-swatch:after,',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag--swatch.tag--active .color-swatch:before,',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag--swatch.tag--active .color-swatch:after{',
        'display:none!important;content:none!important;',
      '}',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag--swatch .tag__text,',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag--swatch.tag--active .tag__text{',
        'display:inline-block!important;visibility:visible!important;opacity:1!important;',
        'font-size:13px!important;line-height:1.2!important;flex:0 1 auto!important;',
        'overflow:visible!important;text-overflow:clip!important;',
        'white-space:nowrap!important;color:var(--colorTextBody,#333)!important;',
        'font-weight:400!important;',
      '}',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag--swatch.tag--active .tag__text{',
        'font-weight:500!important;',
      '}',
      '.collection-mobile-filters .collapsible-content__inner .tag-list li.tag--swatch.tag--active .color-swatch{',
        'box-shadow:0 0 0 1px rgba(0,0,0,0.2)!important;',
      '}',

      '.collection-mobile-filters .collapsible-trigger__layout{font-size:20px;}',
      '}'
    ].join('');
    }
    style.textContent = _cachedStyleCSS;
  }




  // ── Action buttons ─────────────────────────────────────────────────────────

  function createActionButton(type, label) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn mobile-filter-actions__btn mobile-filter-actions__btn--' + type;
    btn.textContent = label;
    return btn;
  }

  function ensureResultsCountEl(wrapper) {
    var footer = wrapper ? wrapper.querySelector(FOOTER_SELECTOR) : null;
    if (!footer) return null;

    var countEl = footer.querySelector(RESULTS_COUNT_SELECTOR);
    if (countEl) return countEl;

    countEl = document.createElement('p');
    countEl.className = 'mobile-filter-results-count';
    countEl.setAttribute('aria-live', 'polite');

    var buttonsWrap = footer.querySelector('.mobile-filter-actions__buttons');
    if (!buttonsWrap) {
      buttonsWrap = document.createElement('div');
      buttonsWrap.className = 'mobile-filter-actions__buttons';
      while (footer.firstChild) {
        buttonsWrap.appendChild(footer.firstChild);
      }
      footer.appendChild(buttonsWrap);
    }

    footer.insertBefore(countEl, buttonsWrap);
    return countEl;
  }

  function ensureMobileActions() {
    var wrapper = getCachedWrapper();
    if (!wrapper) return;
    if (wrapper.querySelector(FOOTER_SELECTOR)) {
      ensureResultsCountEl(wrapper);
      return;
    }
    var footer = document.createElement('div');
    footer.className = 'mobile-filter-actions';

    var countEl = document.createElement('p');
    countEl.className = 'mobile-filter-results-count';
    countEl.setAttribute('aria-live', 'polite');

    var buttonsWrap = document.createElement('div');
    buttonsWrap.className = 'mobile-filter-actions__buttons';
    buttonsWrap.appendChild(createActionButton('reset', 'Reset'));
    buttonsWrap.appendChild(createActionButton('apply', 'Apply'));

    footer.appendChild(countEl);
    footer.appendChild(buttonsWrap);
    wrapper.appendChild(footer);
    ensureDrawerStructure();
  }

  // ── Intercept theme's server-rendered pill clicks ──────────────────────────

  document.addEventListener('click', function (event) {
    if (!isMobileViewport()) return;
    var target = event.target;
    if (!target || !target.closest) return;
    var tagList = target.closest('.tag-list--active-tags');
    if (!tagList || !tagList.closest(MOBILE_FILTER_WRAPPER_SELECTOR)) return;
    var pill = target.closest('.tag--remove');
    if (!pill || pill.hasAttribute('data-key')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var link = pill.querySelector('a[href]');
    if (link) {
      try {
        var pillParams = new URLSearchParams(link.getAttribute('href').split('?')[1] || '');
        var currentParams = getCurrentSearchParams();
        var wrapper = getCachedWrapper();
        currentParams.forEach(function (value, key) {
          if (key.indexOf('filter.') !== 0) return;
          var inPill = pillParams.getAll(key).indexOf(value) !== -1;
          if (!inPill && wrapper) {
            wrapper.querySelectorAll('input[name="' + attrEscape(key) + '"]').forEach(function (inp) {
              if (inp.value === value) inp.checked = false;
            });
          }
        });
      } catch (e) {}
    }
    pill.remove();
  }, true);

  // ── Delegated button handlers ──────────────────────────────────────────────

  document.addEventListener('click', function (event) {
    if (!isMobileViewport()) return;

    // RESET — fetch fresh options from Shopify, restore full unfiltered lists.
    if (event.target.closest('.mobile-filter-actions__btn--reset')) {
      var wrapper = getCachedWrapper();
      if (!wrapper) return;

      wrapper.querySelectorAll('input[type="checkbox"]:checked').forEach(function (inp) {
        if (!inp.name || inp.name.indexOf('filter.') !== 0) return;
        inp.checked = false;
        inp.removeAttribute('checked');
        var li = inp.closest('li.tag');
        if (li) li.classList.remove('tag--active');
      });

      var priceRange = wrapper.querySelector('.price-range');
      if (priceRange) clearPriceRangeFilter(priceRange);

      var pillContainer = wrapper.querySelector('.' + NCC_PILLS_CLASS);
      if (pillContainer) pillContainer.innerHTML = '';
      removedOrphanKeys = {};

      var cleanParams = new URLSearchParams();
      getCurrentSearchParams().forEach(function (val, key) {
        if (key === 'sort_by') cleanParams.set(key, val);
      });
      var qs = cleanParams.toString();
      var cleanUrl = window.location.pathname + (qs ? '?' + qs : '');
      history.pushState({}, '', cleanUrl);
      pendingUrlChange = true;

      drawerPreviewRequestId++;
      clearTimeout(drawerPreviewTimer);

      var currentForm = wrapper.querySelector('form');
      var cached = null;
      try { cached = sessionStorage.getItem(FORM_CACHE_KEY); } catch (e) {}

      if (cached && currentForm) {
        var cachedDoc = new DOMParser().parseFromString('<form>' + cached + '</form>', 'text/html');
        var cachedForm = cachedDoc.querySelector('form');
        if (cachedForm) {
          restoreOptionLists(cachedForm, currentForm, 'reset:cache');
          wrapper.querySelectorAll('input[type="checkbox"]').forEach(function (inp) {
            if (!inp.name || inp.name.indexOf('filter.') !== 0) return;
            inp.checked = false;
            inp.removeAttribute('checked');
            var li = inp.closest('li.tag');
            if (li) li.classList.remove('tag--active');
          });
          updateFilterGroupVisibility(wrapper);
          recalcCollapsibleHeights(wrapper);
        }
      }

      rebuildGroupedPills();

      var sectionId = getCollectionSectionId();
      var fetchUrl = sectionId
        ? cleanUrl + (cleanUrl.indexOf('?') !== -1 ? '&' : '?') + 'sections=' + encodeURIComponent(sectionId)
        : cleanUrl;

      _originalFetch(fetchUrl)
        .then(function (r) {
          return sectionId ? r.json() : r.text();
        })
        .then(function (data) {
          var doc;
          if (sectionId && data && data[sectionId]) {
            doc = new DOMParser().parseFromString(data[sectionId], 'text/html');
          } else if (typeof data === 'string') {
            doc = new DOMParser().parseFromString(data, 'text/html');
          }
          if (!doc) return;

          updateProductGridFromDocument(doc);
          updateCollectionCountFromDocument(doc);

          if (!cached && currentForm) {
            var fetchedForm = findFilterFormInDocument(doc);
            if (fetchedForm) {
              restoreOptionLists(fetchedForm, currentForm, 'reset:fetch');
              wrapper.querySelectorAll('input[type="checkbox"]').forEach(function (inp) {
                if (!inp.name || inp.name.indexOf('filter.') !== 0) return;
                inp.checked = false;
                inp.removeAttribute('checked');
                var li = inp.closest('li.tag');
                if (li) li.classList.remove('tag--active');
              });
              updateFilterGroupVisibility(wrapper);
              recalcCollapsibleHeights(wrapper);
              try { sessionStorage.setItem(FORM_CACHE_KEY, fetchedForm.innerHTML); } catch (e) {}
              rebuildGroupedPills();
            }
          }

          var countText = getCountTextFromDocument(doc);
          if (countText) setDrawerCountText(wrapper, countText);
        })
        .catch(function (err) {
          mfLog('reset:fetchError', { error: err && err.message ? err.message : String(err) });
          window.location.href = cleanUrl;
        });

      return;
    }

    // APPLY
    if (event.target.closest('.mobile-filter-actions__btn--apply')) {
      var applyWrapper = document.querySelector(MOBILE_FILTER_WRAPPER_SELECTOR);
      if (!applyWrapper || !applyWrapper.querySelector('form')) return;
      navigateWithParams(buildFilterParamsFromWrapper(applyWrapper));
      return;
    }

    setTimeout(syncDrawerOpenState, 0);
  });

  // ── Block form submit ──────────────────────────────────────────────────────

  document.addEventListener('submit', function (event) {
    if (!isMobileViewport()) return;
    if (event.target && event.target.closest(MOBILE_FILTER_WRAPPER_SELECTOR)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  // ── Change / input handlers ────────────────────────────────────────────────

  document.addEventListener('change', function (event) {
    if (!isMobileViewport()) return;
    var target = event.target;
    if (!target || !target.closest) return;
    if (!target.closest(MOBILE_FILTER_WRAPPER_SELECTOR)) return;
    if (target.type === 'checkbox') {
      var checkboxKey = pillKeyFor(target.name, target.value);
      if (target.checked) {
        delete removedOrphanKeys[checkboxKey];
      } else {
        // After Apply, URL still has this filter — mark it removed so preview/params
        // do not re-append it from orphan pills and re-check the box.
        removedOrphanKeys[checkboxKey] = true;
      }
      syncFilterCheckboxUi(target);
      mfLog('filter:change:checkbox', {
        key: checkboxKey,
        checked: target.checked,
        label: getInputLabel(target)
      });
      requestAnimationFrame(function () { rebuildGroupedPills(); });
      scheduleDrawerPreviewRefresh('change:checkbox');
      return;
    }
    if (target.tagName === 'SELECT') {
      rebuildGroupedPills();
      scheduleDrawerPreviewRefresh('change:select');
    }
  }, true);

  // Backup for themes that toggle checkboxes without firing change in the drawer.
  document.addEventListener('click', function (event) {
    if (!isMobileViewport() || !isDrawerOpen()) return;
    var target = event.target;
    if (!target || !target.closest) return;
    var checkbox = target.closest(MOBILE_FILTER_WRAPPER_SELECTOR + ' input[type="checkbox"]');
    if (!checkbox) return;
    setTimeout(function () {
      if (!isDrawerOpen()) return;
      var checkboxKey = pillKeyFor(checkbox.name, checkbox.value);
      if (checkbox.checked) {
        delete removedOrphanKeys[checkboxKey];
      } else {
        removedOrphanKeys[checkboxKey] = true;
      }
      syncFilterCheckboxUi(checkbox);
      mfLog('filter:click:checkbox', {
        key: checkboxKey,
        checked: checkbox.checked,
        label: getInputLabel(checkbox)
      });
      requestAnimationFrame(function () { rebuildGroupedPills(); });
      scheduleDrawerPreviewRefresh('click:checkbox');
    }, 0);
  }, true);

  document.addEventListener('input', function (event) {
    if (!isMobileViewport()) return;
    var target = event.target;
    if (target && target.closest && target.closest(MOBILE_FILTER_WRAPPER_SELECTOR)) {
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('price-range:change', function (event) {
    if (!isMobileViewport()) return;
    var target = event.target;
    if (target && target.closest && target.closest(MOBILE_FILTER_WRAPPER_SELECTOR)) {
      event.stopImmediatePropagation();
      rebuildGroupedPills();
      scheduleDrawerPreviewRefresh('price-range:change');
    }
  }, true);

  // ── Form cache ────────────────────────────────────────────────────────────
  // Save unfiltered form HTML on clean pages only (used after successful Reset).

  function paramsHasFilters(params) {
    var has = false;
    if (!params || !params.forEach) return false;
    params.forEach(function (val, key) {
      if (key.indexOf('filter.') === 0) has = true;
    });
    return has;
  }

  function cacheFormIfClean() {
    if (paramsHasFilters(getCurrentSearchParams())) return;
    var wrapper = getCachedWrapper();
    if (wrapper && paramsHasFilters(buildFilterParamsFromWrapper(wrapper))) return;
    var form = wrapper ? wrapper.querySelector('form') : document.querySelector(MOBILE_FILTER_WRAPPER_SELECTOR + ' form');
    if (!form) return;
    try { sessionStorage.setItem(FORM_CACHE_KEY, form.innerHTML); } catch (e) {}
  }

  function updateProductGridFromDocument(doc) {
    if (!doc) return false;
    var gridSelectors = [
      '.grid--products', '.product-grid', '.collection__products',
      '.product-list', '.collection-grid'
    ];
    for (var i = 0; i < gridSelectors.length; i++) {
      var fetchedGrid = doc.querySelector(gridSelectors[i]);
      var liveGrid = document.querySelector(gridSelectors[i]);
      if (fetchedGrid && liveGrid && !liveGrid.closest('#CollectionInlineFilterWrap')) {
        liveGrid.innerHTML = fetchedGrid.innerHTML;
        return true;
      }
    }
    return false;
  }

  function updateCollectionCountFromDocument(doc) {
    if (!doc) return '';
    var countText = getCountTextFromDocument(doc);
    var fetchedCount = doc.querySelector('.collection-filter__item--count');
    var liveCount = document.querySelector('.collection-filter__item--count');
    if (fetchedCount && liveCount) liveCount.innerHTML = fetchedCount.innerHTML;
    return countText;
  }

  function getCollectionSectionId() {
    var ajaxResult = document.querySelector('#CollectionAjaxResult[data-section-id]');
    if (ajaxResult) return ajaxResult.getAttribute('data-section-id');

    var itemGrid = document.querySelector('item-grid[data-section-id]');
    if (itemGrid) return itemGrid.getAttribute('data-section-id');

    var anchor = document.querySelector('.collection-grid__wrapper') ||
                 document.querySelector('[data-section-type]');
    if (!anchor) return null;
    var section = anchor.closest('[id^="shopify-section-"]');
    return section ? section.id.replace('shopify-section-', '') : null;
  }

  function appendFormFilterParams(form, params) {
    if (!form) return;

    form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (inp) {
      if (inp.name) params.append(inp.name, inp.value);
    });
    form.querySelectorAll('input[type="radio"]:checked').forEach(function (inp) {
      if (inp.name) params.set(inp.name, inp.value);
    });
    form.querySelectorAll('select').forEach(function (sel) {
      if (sel.name && sel.value) params.set(sel.name, sel.value);
    });

    var priceRange = form.querySelector('.price-range');
    form.querySelectorAll('input[type="number"], input[type="text"]').forEach(function (inp) {
      if (!inp.name || inp.value === '' || inp.closest('.price-range')) return;
      params.set(inp.name, inp.value);
    });

    if (priceRange) {
      var minRange = parseFloat(priceRange.getAttribute('data-min'));
      var maxRange = parseFloat(priceRange.getAttribute('data-max'));
      var minInp = priceRange.querySelector('.price-range__input-min');
      var maxInp = priceRange.querySelector('.price-range__input-max');
      if (minInp && maxInp && minInp.name && maxInp.name) {
        var minVal = parseFloat(minInp.value);
        var maxVal = parseFloat(maxInp.value);
        if (!isNaN(minVal) && !isNaN(maxVal) && !isNaN(minRange) && !isNaN(maxRange)) {
          if (minVal > minRange || maxVal < maxRange) {
            params.set(minInp.name, minInp.value);
            params.set(maxInp.name, maxInp.value);
          }
        }
      }
    }
  }

  function buildFilterParamsFromWrapper(wrapper) {
    var form = wrapper ? wrapper.querySelector('form') : null;
    var params = new URLSearchParams();

    appendFormFilterParams(form, params);

    // Ensure all checked drawer filters are included (same scope as pills).
    if (wrapper) {
      wrapper.querySelectorAll('input[type="checkbox"]:checked').forEach(function (inp) {
        if (!inp.name) return;
        var exists = false;
        params.getAll(inp.name).forEach(function (val) {
          if (val === inp.value) exists = true;
        });
        if (!exists) params.append(inp.name, inp.value);
      });
    }

    var ourPills = wrapper ? wrapper.querySelector('.' + NCC_PILLS_CLASS) : null;
    if (ourPills) {
      ourPills.querySelectorAll('.ncc-pill-value[data-orphan="1"]').forEach(function (pill) {
        var key = pill.getAttribute('data-key') || '';
        if (removedOrphanKeys[key]) return;
        var sep = key.indexOf('::');
        if (sep === -1) return;
        params.append(key.slice(0, sep), key.slice(sep + 2));
      });
    }

    var currentParams = getCurrentSearchParams();
    if (!params.has('sort_by') && currentParams.has('sort_by')) {
      params.set('sort_by', currentParams.get('sort_by'));
    }
    params.delete('page');
    return params;
  }

  function formatResultsAvailable(count) {
    if (isNaN(count) || count < 0) return '';
    if (count === 1) return '1 result available';
    return count + ' results available';
  }

  function getCountTextFromDocument(doc) {
    if (!doc) return '';

    var countSelectors = [
      '#CollectionAjaxContent .collection-filter__item--count',
      '.collection-grid__wrapper .collection-filter__item--count',
      '.collection-filter__item--count',
      '[data-collection-count]'
    ];
    var i;
    for (i = 0; i < countSelectors.length; i++) {
      var el = doc.querySelector(countSelectors[i]);
      if (el && el.textContent.trim()) return el.textContent.trim();
    }

    var countNodes = doc.querySelectorAll('[data-collection-count]');
    for (i = 0; i < countNodes.length; i++) {
      if (countNodes[i].textContent.trim()) return countNodes[i].textContent.trim();
    }

    var paginations = doc.querySelectorAll('.pagination_pro[data-total-products]');
    for (i = 0; i < paginations.length; i++) {
      var pagination = paginations[i];
      var total = parseInt(pagination.getAttribute('data-total-products'), 10);
      if (!isNaN(total)) return formatResultsAvailable(total);
      var pageText = pagination.textContent || '';
      var ofMatch = pageText.match(/of\s+([\d,.]+)\s+Products/i);
      if (ofMatch) {
        total = parseInt(ofMatch[1].replace(/[,.]/g, ''), 10);
        if (!isNaN(total)) return formatResultsAvailable(total);
      }
    }

    return '';
  }

  function extractCountFromHtml(html) {
    if (!html) return '';
    return getCountTextFromDocument(new DOMParser().parseFromString(html, 'text/html'));
  }

  function updateDrawerCountFromPage(wrapper) {
    var countEl = ensureResultsCountEl(wrapper);
    if (!countEl) return;
    var text = getCountTextFromDocument(document);
    if (text) {
      countEl.textContent = text;
      countEl.classList.remove('is-loading');
    }
  }

  function setDrawerCountText(wrapper, text) {
    var countEl = ensureResultsCountEl(wrapper);
    if (!countEl || !text) return;
    countEl.textContent = text;
    countEl.classList.remove('is-loading');
  }

  function clearCountLoadingState(wrapper) {
    clearTimeout(countLoadingTimer);
    countLoadingTimer = null;
    if (!wrapper) wrapper = document.querySelector(MOBILE_FILTER_WRAPPER_SELECTOR);
    if (!wrapper) return;
    var countEl = wrapper.querySelector(RESULTS_COUNT_SELECTOR);
    if (countEl) countEl.classList.remove('is-loading');
  }

  function scheduleCountLoadingIndicator(wrapper, requestId) {
    clearTimeout(countLoadingTimer);
    var countEl = ensureResultsCountEl(wrapper);
    if (countEl) countEl.classList.remove('is-loading');

    countLoadingTimer = setTimeout(function () {
      if (requestId !== drawerPreviewRequestId) return;
      var el = wrapper.querySelector(RESULTS_COUNT_SELECTOR);
      if (el) el.classList.add('is-loading');
    }, COUNT_LOADING_DELAY_MS);
  }

  function buildSectionApiUrl(params) {
    var sectionId = getCollectionSectionId();
    if (!sectionId) return null;
    var qs = params.toString();
    var baseUrl = window.location.pathname + (qs ? '?' + qs : '');
    return baseUrl +
      (baseUrl.indexOf('?') !== -1 ? '&' : '?') +
      'sections=' + encodeURIComponent(sectionId);
  }

  function findFilterFormInDocument(doc) {
    return doc.querySelector('#CollectionInlineFilterWrap form') ||
           doc.querySelector('#CollectionSidebarFilterWrap .filter-wrapper form') ||
           doc.querySelector('#CollectionSidebarFilterWrap form') ||
           doc.querySelector('.collection-sidebar form.filter-form') ||
           doc.querySelector('.filter-form');
  }

  function getFilterGroupKey(groupEl) {
    if (!groupEl) return '';
    var content = groupEl.querySelector('[data-collapsible-id]');
    if (content) return content.getAttribute('data-collapsible-id') || '';
    var trigger = groupEl.querySelector('.collapsible-trigger[data-controls]');
    if (trigger) return trigger.getAttribute('data-controls') || '';
    var panel = groupEl.querySelector('.collapsible-content[data-id]');
    if (panel) return panel.getAttribute('data-id') || '';
    return '';
  }

  function getFilterGroupOuterEl(groupEl) {
    var parent = groupEl.parentElement;
    if (parent && parent.className && String(parent.className).indexOf('collection-sidebar__group--') !== -1) {
      return parent;
    }
    return groupEl;
  }

  function restoreOptionLists(sourceForm, targetForm, logContext) {
    var targetGroupsByKey = {};
    var targetGroups = targetForm.querySelectorAll('.collection-sidebar__group');
    var swapped = [];

    targetGroups.forEach(function (group) {
      var key = getFilterGroupKey(group);
      if (key) targetGroupsByKey[key] = group;
    });

    sourceForm.querySelectorAll('.collection-sidebar__group').forEach(function (sourceGroup, index) {
      if (sourceGroup.classList.contains('collection-sidebar__group--sort')) return;

      var key = getFilterGroupKey(sourceGroup);
      var targetGroup = (key && targetGroupsByKey[key]) || targetGroups[index];
      if (!targetGroup || targetGroup.classList.contains('collection-sidebar__group--sort')) return;

      var sourceList = sourceGroup.querySelector('.collapsible-content__inner ul.no-bullets.tag-list');
      var targetList = targetGroup.querySelector('.collapsible-content__inner ul.no-bullets.tag-list');
      if (sourceList && targetList) {
        var sourceChecked = [];
        sourceList.querySelectorAll('input[type="checkbox"]:checked').forEach(function (inp) {
          sourceChecked.push(inp.name + '::' + inp.value);
        });
        targetList.innerHTML = sourceList.innerHTML;
        swapped.push({
          groupKey: key || ('index:' + index),
          sourceCheckedInHtml: sourceChecked
        });
      }
    });

    mfLog('restoreOptionLists', {
      context: logContext || 'unspecified',
      swappedGroups: swapped.length,
      swapped: swapped,
      checkedAfterSwap: getCheckedFilterKeys(targetForm.closest('.filter-wrapper'))
    });

    var targetWrapper = targetForm.closest('.filter-wrapper');
    if (targetWrapper) recalcCollapsibleHeights(targetWrapper);
  }

  function syncCheckboxStateFromParams(wrapper, params, logContext) {
    var changes = [];
    wrapper.querySelectorAll('input[type="checkbox"]').forEach(function (inp) {
      if (!inp.name || inp.name.indexOf('filter.') !== 0) return;
      var shouldCheck = false;
      params.getAll(inp.name).forEach(function (val) {
        if (val === inp.value) shouldCheck = true;
      });
      var wasChecked = inp.checked;
      var wasActive = !!(inp.closest('li.tag') && inp.closest('li.tag').classList.contains('tag--active'));
      inp.checked = shouldCheck;
      if (shouldCheck) {
        inp.setAttribute('checked', 'checked');
      } else {
        inp.removeAttribute('checked');
      }
      var li = inp.closest('li.tag');
      if (li) {
        if (shouldCheck) li.classList.add('tag--active');
        else li.classList.remove('tag--active');
      }
      if (wasChecked !== shouldCheck || wasActive !== shouldCheck) {
        changes.push({
          key: inp.name + '::' + inp.value,
          wasChecked: wasChecked,
          nowChecked: shouldCheck,
          connected: inp.isConnected
        });
      }
    });
    if (logContext || changes.length) {
      mfLog('syncCheckboxStateFromParams', {
        context: logContext || 'unspecified',
        changeCount: changes.length,
        changes: changes,
        params: paramsToFilterObject(params),
        checkedAfter: getCheckedFilterKeys(wrapper)
      });
    }
  }

  function updateFilterGroupVisibility(wrapper) {
    wrapper.querySelectorAll('.collection-sidebar__group').forEach(function (group) {
      if (group.classList.contains('collection-sidebar__group--sort')) return;

      var outer = getFilterGroupOuterEl(group);

      if (group.querySelector('.price-range')) {
        outer.style.display = '';
        return;
      }

      var list = group.querySelector('.collapsible-content__inner ul.no-bullets.tag-list');
      if (!list) {
        outer.style.display = '';
        return;
      }

      var visibleCount = list.querySelectorAll('li:not(.hide)').length;
      outer.style.display = visibleCount > 0 ? '' : 'none';
    });
  }

  function applyFilterPreviewFromDocument(doc, wrapper, params, logContext) {
    var fetchedForm = findFilterFormInDocument(doc);
    var currentForm = wrapper.querySelector('form');

    mfLog('applyFilterPreviewFromDocument:start', {
      context: logContext || 'unspecified',
      hasFetchedForm: !!fetchedForm,
      hasCurrentForm: !!currentForm,
      params: paramsToFilterObject(params),
      checkedBefore: getCheckedFilterKeys(wrapper)
    });

    var scrollArea = getCachedScrollArea();
    var savedScroll = scrollArea ? scrollArea.scrollTop : 0;

    if (fetchedForm && currentForm) {
      restoreOptionLists(fetchedForm, currentForm, logContext || 'applyFilterPreview');
      // Use live drawer state (not fetch-time params) so a slow preview cannot
      // re-check filters the shopper already unchecked.
      var liveParams = buildFilterParamsFromWrapper(wrapper);
      syncCheckboxStateFromParams(wrapper, liveParams, logContext || 'applyFilterPreview');
      mfLogCheckboxMismatch(wrapper, liveParams, 'after ' + (logContext || 'applyFilterPreview'));
      updateFilterGroupVisibility(wrapper);
      recalcCollapsibleHeights(wrapper);
    }

    var countText = getCountTextFromDocument(doc);
    if (countText) setDrawerCountText(wrapper, countText);
    markColorFilterLists(wrapper);
    rebuildGroupedPills();

    if (scrollArea) scrollArea.scrollTop = savedScroll;

    mfLog('applyFilterPreviewFromDocument:done', {
      context: logContext || 'unspecified',
      countText: countText || null,
      checkedAfter: getCheckedFilterKeys(wrapper)
    });
  }

  function fetchPreviewDocument(params, signal) {
    var qs = params.toString();
    var pageUrl = window.location.pathname + (qs ? '?' + qs : '');
    var fetchOpts = signal ? { signal: signal } : {};

    function fetchFullPageDoc() {
      return _originalFetch(pageUrl, fetchOpts).then(function (r) {
        if (!r.ok) throw new Error('Preview fetch failed');
        return r.text();
      }).then(function (html) {
        return new DOMParser().parseFromString(html, 'text/html');
      });
    }

    var apiUrl = buildSectionApiUrl(params);
    if (!apiUrl) return fetchFullPageDoc();

    var sectionId = getCollectionSectionId();
    return _originalFetch(apiUrl, fetchOpts)
      .then(function (r) {
        if (!r.ok) throw new Error('sections fetch failed');
        return r.json();
      })
      .then(function (data) {
        if (data && data[sectionId]) {
          return new DOMParser().parseFromString(data[sectionId], 'text/html');
        }
        return fetchFullPageDoc();
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') throw err;
        return fetchFullPageDoc();
      });
  }

  function scheduleDrawerPreviewRefresh(source) {
    if (!isDrawerOpen()) return;
    clearTimeout(drawerPreviewTimer);
    mfLog('preview:scheduled', { source: source || 'unknown', delayMs: PREVIEW_DEBOUNCE_MS });
    drawerPreviewTimer = setTimeout(function () {
      refreshDrawerPreview(source || 'scheduled');
    }, PREVIEW_DEBOUNCE_MS);
  }

  function refreshDrawerPreview(source) {
    var wrapper = getCachedWrapper();
    if (!wrapper || !isDrawerOpen()) return;

    if (!ensureResultsCountEl(wrapper)) return;

    var params = buildFilterParamsFromWrapper(wrapper);
    var requestId = ++drawerPreviewRequestId;

    if (_previewAbortController) {
      try { _previewAbortController.abort(); } catch (e) {}
    }
    _previewAbortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var signal = _previewAbortController ? _previewAbortController.signal : undefined;

    mfLog('preview:fetch:start', {
      source: source || 'unknown',
      requestId: requestId,
      params: paramsToFilterObject(params),
      checkedBeforeFetch: getCheckedFilterKeys(wrapper)
    });

    scheduleCountLoadingIndicator(wrapper, requestId);

    fetchPreviewDocument(params, signal)
      .then(function (doc) {
        if (requestId !== drawerPreviewRequestId) {
          mfLog('preview:fetch:stale', {
            source: source || 'unknown',
            requestId: requestId,
            currentPreviewRequestId: drawerPreviewRequestId,
            params: paramsToFilterObject(params)
          });
          return;
        }
        mfLog('preview:fetch:complete', {
          source: source || 'unknown',
          requestId: requestId,
          params: paramsToFilterObject(params)
        });
        applyFilterPreviewFromDocument(doc, wrapper, params, 'preview:' + (source || 'unknown'));
        clearCountLoadingState(wrapper);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (requestId !== drawerPreviewRequestId) return;
        mfLog('preview:fetch:error', {
          source: source || 'unknown',
          requestId: requestId,
          error: err && err.message ? err.message : String(err)
        });
        clearCountLoadingState(wrapper);
      });
  }

  function softReset(cleanUrl, wrapper, drawerParams) {
    function syncDrawerCheckboxes(step) {
      var params = drawerParams || buildFilterParamsFromWrapper(wrapper);
      syncCheckboxStateFromParams(wrapper, params, 'softReset:' + step);
      mfLogCheckboxMismatch(wrapper, params, 'softReset:' + step);
      return params;
    }

    mfLog('softReset:start', {
      cleanUrl: cleanUrl,
      drawerParams: paramsToFilterObject(drawerParams),
      checkedBefore: getCheckedFilterKeys(wrapper)
    });

    var cached = null;
    try { cached = sessionStorage.getItem(FORM_CACHE_KEY); } catch (e) {}
    var currentForm = wrapper.querySelector('form');

    if (cached && currentForm) {
      mfLog('softReset:cacheRestore', { cacheKey: FORM_CACHE_KEY, cacheBytes: cached.length });
      var cachedDoc = new DOMParser().parseFromString('<form>' + cached + '</form>', 'text/html');
      var cachedForm = cachedDoc.querySelector('form');
      restoreOptionLists(cachedForm, currentForm, 'softReset:cache');
      syncDrawerCheckboxes('afterCacheRestore');
      updateFilterGroupVisibility(wrapper);
    } else if (currentForm) {
      mfLog('softReset:noCache', { cleanUrl: cleanUrl });
      _originalFetch(cleanUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fetched = new DOMParser().parseFromString(html, 'text/html');
          var fetchedForm = findFilterFormInDocument(fetched);
          if (fetchedForm) {
            try { sessionStorage.setItem(FORM_CACHE_KEY, fetchedForm.innerHTML); } catch (e) {}
            restoreOptionLists(fetchedForm, currentForm, 'softReset:fetch');
            syncDrawerCheckboxes('afterFetchRestore');
            updateFilterGroupVisibility(wrapper);
          }
        })
        .catch(function (err) {
          mfLog('softReset:fetchError', { error: err && err.message ? err.message : String(err) });
        });
    }

    var sectionId = getCollectionSectionId();
    if (!sectionId) {
      mfLog('softReset:noSectionId', {});
      return;
    }

    var apiUrl = cleanUrl +
      (cleanUrl.indexOf('?') !== -1 ? '&' : '?') +
      'sections=' + encodeURIComponent(sectionId);

    _originalFetch(apiUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data[sectionId]) return;

        var newDoc = new DOMParser().parseFromString(data[sectionId], 'text/html');
        updateProductGridFromDocument(newDoc);
        var countText = updateCollectionCountFromDocument(newDoc);
        if (countText) setDrawerCountText(wrapper, countText);

        if (isDrawerOpen()) {
          var previewParams = drawerParams || buildFilterParamsFromWrapper(wrapper);
          mfLog('softReset:sectionFetch:complete', {
            cleanUrl: cleanUrl,
            previewParams: paramsToFilterObject(previewParams),
            checkedBeforeApply: getCheckedFilterKeys(wrapper)
          });
          applyFilterPreviewFromDocument(newDoc, wrapper, previewParams, 'softReset:section');
        }
      })
      .catch(function (err) {
        mfLog('softReset:sectionFetch:error', {
          error: err && err.message ? err.message : String(err)
        });
      });
  }

  // ── Setup ──────────────────────────────────────────────────────────────────

  function setupMobileFilterActions() {
    _ric(cacheFormIfClean);
    syncHeaderOffsetVar();
    injectActionStyles();
    ensureMobileActions();
    ensureDrawerStructure();
    getPillContainer();
    seedPillsFromURL();
    var wrapper = getCachedWrapper();
    if (wrapper) markColorFilterLists(wrapper);
    syncDrawerOpenState();
  }

  function debouncedSetup() {
    clearTimeout(setupDebounceTimer);
    setupDebounceTimer = setTimeout(function () {
      if (isRunningSetup) return;
      isRunningSetup = true;
      invalidateDomCache();
      try { setupMobileFilterActions(); }
      finally { isRunningSetup = false; }
    }, 60);
  }

  function isPillOnlyMutation(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var target = mutations[i].target;
      if (!target || !target.closest) continue;
      if (target.classList && target.classList.contains(NCC_PILLS_CLASS)) continue;
      if (target.closest('.' + NCC_PILLS_CLASS)) continue;
      return false;
    }
    return mutations.length > 0;
  }

  function observeFilterWrapper() {
    var inlineWrap = document.querySelector(INLINE_WRAP_SELECTOR);
    if (!inlineWrap) return;
    var observer = new MutationObserver(function (mutations) {
      if (isPillOnlyMutation(mutations)) return;
      debouncedSetup();
    });
    observer.observe(inlineWrap, { childList: true, subtree: true });
  }

  // Watch the PARENT (#CollectionInlineFilterWrap) for class changes on any
  // descendant .filter-wrapper. Watching the wrapper directly breaks if the
  // theme replaces it via AJAX — the old ref is detached and never fires.
  // Observing the parent with subtree:true catches the new wrapper too.
  function getFilterWrapperFromNode(node) {
    if (!node) return null;
    if (node.classList && node.classList.contains('filter-wrapper')) return node;
    if (node.querySelector) {
      var inner = node.querySelector('.filter-wrapper');
      if (inner) return inner;
    }
    return document.querySelector(MOBILE_FILTER_WRAPPER_SELECTOR);
  }

  function handleDrawerWrapperOpen(wrapper) {
    if (!wrapper) return;
    syncDrawerOpenState();
    onDrawerOpened();
  }

  function handleDrawerWrapperClose(wrapper) {
    resetDrawerExpandState();
    restorePageHeader();
    unlockBodyScroll();
    stopOffsetSyncLoop();
    drawerPreviewRequestId++;
    clearTimeout(drawerPreviewTimer);
    if (_previewAbortController) {
      try { _previewAbortController.abort(); } catch (e) {}
      _previewAbortController = null;
    }
    if (wrapper) clearCountLoadingState(wrapper);
    invalidateDomCache();
    if (pendingUrlChange) {
      pendingUrlChange = false;
      window.location.href = window.location.href;
    }
  }

  function observeWrapperClass() {
    var inlineWrap = document.querySelector(INLINE_WRAP_SELECTOR);
    if (!inlineWrap) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        var t = mutation.target;
        if (!t.classList) continue;

        var isWrap = t === inlineWrap || t.id === 'CollectionInlineFilterWrap';
        var isWrapper = t.classList.contains('filter-wrapper');
        if (!isWrap && !isWrapper) continue;

        var wrapper = getFilterWrapperFromNode(isWrapper ? t : t);
        if (!wrapper) continue;

        var oldClass = mutation.oldValue || '';
        var newClass = t.getAttribute('class') || '';
        var lostActive = classAttrHasToken(oldClass, 'is-active') &&
          !classAttrHasToken(newClass, 'is-active');

        if (lostActive) {
          handleDrawerWrapperClose(wrapper);
          return;
        }

        if (isFilterDrawerActive(wrapper)) {
          handleDrawerWrapperOpen(wrapper);
          return;
        }
      }
    }).observe(inlineWrap, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
      attributeOldValue: true
    });

    document.addEventListener('click', function (event) {
      if (!isMobileViewport()) return;
      if (!event.target.closest(FILTER_TRIGGER_SELECTOR)) return;
      setTimeout(function () {
        var wrapper = document.querySelector(MOBILE_FILTER_WRAPPER_SELECTOR);
        if (wrapper && isFilterDrawerActive(wrapper)) {
          handleDrawerWrapperOpen(wrapper);
        }
      }, 0);
    }, true);
  }

  // ── Boot ───────────────────────────────────────────────────────────────────

  window.nccMobileFiltersDebug = {
    enabled: isMfLogEnabled,
    enable: function () {
      try { localStorage.setItem('ncc_filter_debug', '1'); } catch (e) {}
      console.log(MF_LOG_PREFIX, 'debug enabled — reload page to persist, or logs work immediately');
    },
    disable: function () {
      try { localStorage.setItem('ncc_filter_debug', '0'); } catch (e) {}
      console.log(MF_LOG_PREFIX, 'debug disabled');
    },
    snapshot: function () {
      var wrapper = getCachedWrapper();
      var params = wrapper ? buildFilterParamsFromWrapper(wrapper) : null;
      return {
        previewRequestId: drawerPreviewRequestId,
        drawerOpen: isDrawerOpen(),
        url: window.location.href,
        params: params ? paramsToFilterObject(params) : null,
        checked: wrapper ? getCheckedFilterKeys(wrapper) : [],
        checkboxes: wrapper ? getDrawerCheckboxSnapshot(wrapper) : []
      };
    },
    log: mfLog
  };

  mfLog('boot', {
    pathname: window.location.pathname,
    debugEnabled: isMfLogEnabled(),
    hint: 'Filter console with: [ncc-filters]  |  Snapshot: nccMobileFiltersDebug.snapshot()'
  });

  document.addEventListener('DOMContentLoaded', function () {
    observeFilterWrapper();
    setTimeout(function () {
      setupMobileFilterActions();
      observeWrapperClass();

    }, 100);
  });

  window.addEventListener('resize', syncHeaderOffsetVar);
  window.addEventListener('scroll', syncHeaderOffsetVar, { passive: true });
  window.addEventListener('orientationchange', syncHeaderOffsetVar);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncHeaderOffsetVar);
    window.visualViewport.addEventListener('scroll', syncHeaderOffsetVar);
  }

  document.addEventListener('touchmove', function (event) {
    if (!isDrawerOpen()) return;
    var target = event.target;
    if (!target || !target.closest || !target.closest(MOBILE_FILTER_WRAPPER_SELECTOR)) {
      event.preventDefault();
    }
  }, { passive: false });

})();